<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idForm" name="nomForm">

        <div class="grid form-group col-12 flex">
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label>{{'CAMPANIADCTODESTINO.LBL_DIAMINMORA' | translate}}:</label>
              <div *ngIf="!campaniaDescuentoMora">
                <input type="text" pInputText id="diaMinMora"
                       name="nomDiaMinMora"
                       autocomplete="off"
                       formControlName="diaMinMora"
                       numero-entero-reactive [maximo]="9999"
                       [maxLength]="4"
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.diaMinMora.invalid">
                  {{ 'CAMPANIADCTODESTINO.LBL_DIAMINMORA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
              <div *ngIf="campaniaDescuentoMora">
                <label class="falso-combo-texto">{{campaniaDescuentoMora.diaMinMora}}</label>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label>{{'CAMPANIADCTODESTINO.LBL_DIAMAXMORA' | translate}}:</label>
              <input type="text" pInputText id="diaMaxMora"
                     name="nomDiaMaxMora"
                     autocomplete="off"
                     formControlName="diaMaxMora"
                     numero-entero-reactive [maximo]="9999"
                     [maxLength]="4"
              >
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.diaMaxMora.invalid">
                {{ 'CAMPANIADCTODESTINO.LBL_DIAMAXMORA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3 ">
            <div class="div-form">
              <label>{{'CAMPANIADCTODESTINO.LBL_DESCUENTOTASA' | translate}}:</label>
              <input type="text" pInputText id="descuentoTasa"
                     name="nomDescuentoTasa"
                     autocomplete="off"
                     formControlName="descuentoTasa"
                     porcentaje-reactive [decimales]="6"
                     [maxLength]="10"
              >
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descuentoTasa.invalid">
                {{ 'CAMPANIADCTODESTINO.LBL_DESCUENTOTASA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3 flex">
            <div class="div-form flex col-12">
              <div class="col-12 md:col-6 lg:col-6">
                <p-radioButton name="indicadorSuma" label="{{ 'CAMPANIADCTODESTINO.LBL_RESTA' | translate}}"
                               formControlName="indicadorSuma"
                               [value]="false"></p-radioButton>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <p-radioButton name="indicadorSuma" label="{{ 'CAMPANIADCTODESTINO.LBL_SUMA' | translate}}"
                               formControlName="indicadorSuma"
                               [value]="true"></p-radioButton>
              </div>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorSuma.invalid">
                {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>

        </div>


        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guardando">
              <button icon="fa fa-plus"
                      label="{{(campaniaDescuentoMora && campaniaDescuentoMora.idCampaniaDescuentoDiaMora)?('BTN_GUARDAR' | translate):('BTN_AGREGAR' | translate) }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="obtenerCampaniasDescuentoHabilitadas()" selectionMode="single" dataKey="idCampaniaDescuentoDiaMora"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="table-break">{{row.diaMinMora}}</td>
            <td class="table-break">{{row.diaMaxMora}}</td>
            <td
              class="table-break">{{(row.descuentoTasa && row.indicadorSuma) ? ('+ ' + row.descuentoTasa) : ('- ' + row.descuentoTasa)}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton
                        (click)="editar(row)"></button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_ELIMINAR' | translate}}" pButton
                        (click)="eliminar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
